import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Temoignages from '@/components/Temoignages';
import type { City } from '@/data/cities';

const testimonials = [
  { name: 'Jennifer Falconi', role: 'Mariée', company: 'Mariage', text: 'Cyrille et Nathalie ont rendu notre mariage unique et chaleureux. La cérémonie laïque était pleine d\'émotion, la décoration a émerveillé nos invités, et les animations ont été extraordinaires.', rating: 5 },
  { name: 'Cécile Bellahsene Boissel', role: 'Mariée', company: 'Mariage', text: 'Un gros coup de cœur. Un mariage organisé en peu de temps et le résultat fut incroyable. Cyrille est un homme avec un cœur en or qui s\'investit sans compter.', rating: 5 },
  { name: 'Olivia Henry', role: 'Mariée', company: 'Mariage', text: 'Cyrille a plus que répondu à nos attentes en nous en mettant plein les yeux. Des shows qui sortent de l\'ordinaire et qui nous ont fait rêver.', rating: 5 },
  { name: 'Sabine Hivet', role: 'Mariée', company: 'Mariage', text: 'Cyrille est un véritable chef d\'orchestre, à l\'écoute, qui a rapidement cerné ce que nous souhaitions. Grâce à lui, nous avons passé un week-end merveilleux.', rating: 5 },
  { name: 'Monica Boitard', role: 'Mariée', company: 'Mariage', text: 'La cérémonie laïque a été magnifique et a beaucoup touché nos invités. Merci pour l\'implication fournie pour faire de cette journée un moment spécial.', rating: 5 },
  { name: 'Aldo Falconi', role: 'Père de la mariée', company: 'Mariage', text: 'Vous pouvez y aller les yeux fermés, ils se sont occupés du mariage de ma fille, une vraie réussite. Ils y mettent tout leur savoir et surtout leur cœur.', rating: 5 },
];

interface Props { city: City }

const VilleTemoignages = ({ city }: Props) => (
  <div>
    <Temoignages testimonials={testimonials} />
    <div className="text-center pb-10 bg-card">
      <a
        href="https://maps.app.goo.gl/SPqj82CAvgbDAqUU6"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-primary font-heading font-medium text-sm hover:gap-3 transition-all"
      >
        Voir tous nos avis Google <ArrowRight size={14} />
      </a>
    </div>
  </div>
);

export default VilleTemoignages;
